import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliverableSubProjectsDataGrid } from "src/components/views/erp/project/delivery/DeliverableSubProjectsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/deliverableSubProjects")({
	staticData: { title: i18n.t("deliverable_sub_projects"), legacyViewKey: "deliverableSubProjectsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliverableSubProjectsDataGrid />;
}
